import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Injector, provideZoneChangeDetection } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import './app/surveyJS-custom-questions/survey-ngform-bridge';

function exposeInjector(injector: Injector) {
  (window as any).injector = injector;
}

const bootstrapProviders = [
  ...(appConfig.providers || []),
  {
    provide: 'GLOBAL_INJECTOR_HOOK',
    useFactory: (injector: Injector) => {
      exposeInjector(injector);
      return true;
    },
    deps: [Injector],
  },
];

function bootstrapApp() {
  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...bootstrapProviders],
  }).catch((err) => console.error('[App] Bootstrap error:', err));
}

async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.warn('[App] Service workers not supported');
    return null;
  }

  try {
    const existingRegistration = await navigator.serviceWorker.getRegistration(
      '/combined-sw.js'
    );

    if (
      !existingRegistration ||
      existingRegistration.active?.scriptURL.includes('combined-sw.js')
    ) {
      const registration = await navigator.serviceWorker.register(
        '/combined-sw.js',
        {
          scope: '/',
          updateViaCache: 'none',
        }
      );

      if (registration.installing) {
        registration.installing.postMessage({ type: 'SKIP_WAITING' });
      }

      await new Promise<void>((resolve) => {
        if (registration.active) {
          resolve();
        } else if (registration.installing) {
          registration.installing.addEventListener('statechange', () => {
            if (registration.installing?.state === 'activated') {
              resolve();
            }
          });
        } else if (registration.waiting) {
          registration.waiting.addEventListener('statechange', () => {
            if (registration.waiting?.state === 'activated') {
              resolve();
            }
          });
        }

        navigator.serviceWorker.addEventListener(
          'controllerchange',
          () => resolve(),
          { once: true }
        );
      });

      return registration;
    }

    return existingRegistration;
  } catch (error) {
    console.error('[App] Service worker registration failed:', error);
    return null;
  }
}

async function startApp() {
  const isWebPlatform = !Capacitor.isNativePlatform();

  // Bootstrap immediately so cached templates can render without waiting for SW.
  bootstrapApp();

  if (isWebPlatform && 'serviceWorker' in navigator) {
    registerServiceWorker().catch((error) => {
      console.error('[App] Background service worker registration failed:', error);
    });
  }
}

startApp();
